import { CountdownTimer } from "./CountdownTimer";
import { Calendar, Clock, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import defaultDivider from "@/assets/decoration/ornament-divider.png";
import defaultFlower from "@/assets/decoration/corner-flower.png";

interface EventSectionProps {
  dividerOrnament?: string;
  cornerFlower?: string;
}

export function EventSection({
  dividerOrnament,
  cornerFlower,
}: EventSectionProps) {
  // Target Date: February 15, 2026, 08:00 WIB (UTC+7)
  const targetDate = new Date("2026-02-15T08:00:00+07:00");

  return (
    <section
      id="event"
      className="relative w-full py-20 px-6 bg-[#EBE7E0] overflow-hidden text-center"
    >
      {/* Corner Decoration - Top Right */}
      <img
        src={cornerFlower || defaultFlower}
        alt="Decoration"
        className="absolute top-0 right-0 w-40 md:w-56 opacity-60 pointer-events-none rotate-90 mix-blend-multiply"
      />

      {/* ... existing SVG decoration */}

      <div className="max-w-md mx-auto relative z-10">
        <motion.h2
          className="font-serif text-3xl mb-12 text-stone-800"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Save The Date
        </motion.h2>

        <motion.div
          className="bg-white/60 backdrop-blur-sm border border-white/50 p-8 rounded-xl shadow-sm"
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex flex-col items-center gap-6">
            {/* Event Type */}
            <h3 className="font-handwriting text-4xl text-stone-700">
              Akad Nikah
            </h3>

            {/* Countdown Timer */}
            <CountdownTimer targetDate={targetDate} />

            {/* Date */}
            <div className="flex flex-col items-center gap-2">
              <Calendar className="w-6 h-6 text-stone-600" />
              <p className="font-serif text-lg font-bold text-stone-800">
                Minggu, 15 Februari 2026
              </p>
            </div>

            {/* Time */}
            <div className="flex flex-col items-center gap-2">
              <Clock className="w-6 h-6 text-stone-600" />
              <p className="text-stone-700">08.00 - 13.00 WIB</p>
            </div>

            {/* Venue */}
            <div className="flex flex-col items-center gap-2">
              <MapPin className="w-6 h-6 text-stone-600" />
              <p className="font-bold text-stone-800">Ponyo Malabar</p>
              <p className="text-sm text-stone-500 max-w-[200px]">
                Jl. Malabar No.60, Malabar, Kec. Lengkong, Kota Bandung, Jawa
                Barat 40262
              </p>
            </div>

            <a
              href="https://maps.app.goo.gl/2M5LmfYuwNTaBJfq6"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4"
            >
              <Button
                variant="outline"
                className="border-stone-400 text-stone-700 hover:bg-stone-700 hover:text-white transition-colors"
              >
                Lihat Lokasi
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
